import React, { useContext } from "react";
import { TemplateInstanceContext } from "../../../Providers/TemplateInstanceProvider";

export default () => {
  const context = useContext(TemplateInstanceContext);
  if (!context) {
    throw new Error(
      "useTemplateInstance must be used within a <TemplateInstance>",
    );
  }
  return context;
};
